var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "quicklink" }, [
    _c("div", { staticClass: "icon" }, [
      _vm.quicklink.icon
        ? _c("img", { attrs: { src: _vm.quicklink.icon.url } })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "quicklink__list" },
      [
        _vm.quicklink.title
          ? _c("h5", { domProps: { innerHTML: _vm._s(_vm.quicklink.title) } })
          : _vm._e(),
        _vm._v(" "),
        _c("transition", { attrs: { name: "accordion" } }, [
          _c(
            "ul",
            _vm._l(_vm.quicklink.links, function (link, index) {
              return _c("menu-item", {
                key: index,
                attrs: { menu_item: link.link },
              })
            }),
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }